import { Action, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { InstallersStateModel } from '@store/general/installers-state.model';
import { SetHasVisitedInstallersList } from '@store/general/installers.actions';

@State<InstallersStateModel>({
  name: 'general',
  defaults: {
    hasVisitedInstallersList: false,
  },
})
@Injectable()
export class InstallersState {
  @Action(SetHasVisitedInstallersList)
  public setHasVisited(ctx: StateContext<InstallersStateModel>, action: SetHasVisitedInstallersList): void {
    ctx.patchState({ hasVisitedInstallersList: action.visited });
  }
}
